import React from "react";
import { useState } from "react";
import { Row, Col } from "reactstrap";

export default function TableDadosDRE({ tableDREData }) {
  const camposDataTable = [
    { tipo: "titulo", label: "RECEITA BRUTA", codigo: "totalWaterfall.totalReceitaBruta" },
    { tipo: "subtitulo", label: "SERVIÇO", codigo: "receitaBrutaServico" },
    { tipo: "campo", label: "COMISSÃO", codigo: "comissao" },
    { tipo: "campo", label: "SEGURO APARELHO", codigo: "seguroAparelho" },
    { tipo: "campo", label: "RECARGA", codigo: "recarga" },
    { tipo: "subtitulo", label: "PRODUTO", codigo: "receitaBrutaProduto" },
    { tipo: "campo", label: "REBATE", codigo: "rebate" },
    { tipo: "campo", label: "ADM", codigo: "adm" },
    { tipo: "campo", label: "PRICE OFERTA", codigo: "priceOferta" },
    { tipo: "campo", label: "PRICE PROTECTION", codigo: "priceProtection" },
    { tipo: "campo", label: "PRICE BACK", codigo: "priceBack" },
    { tipo: "campo", label: "OUTROS", codigo: "outrosReembolso" },
    { tipo: "campo", label: "APARELHO", codigo: "aparelho" },
    { tipo: "campo", label: "CHIP", codigo: "chip" },
    { tipo: "campo", label: "ACESSÓRIO", codigo: "acessorio" },
    { tipo: "campo", label: "RECEITAS ADICIONAIS", codigo: "receitasAdicionais" },
    { tipo: "titulo", label: "IMPOSTO", codigo: "totalWaterfall.totalImposto" },
    { tipo: "campo", label: "PIS/COFINS - Serviço", codigo: "pisCofinsServico" },
    { tipo: "campo", label: "PIS/COFINS - Seguro", codigo: "pisCofinsSeguro" },
    { tipo: "campo", label: "PIS/COFINS - Chip", codigo: "pisCofinsChip" },
    { tipo: "campo", label: "PIS/COFINS - Recarga", codigo: "pisCofinsRecarga" },
    { tipo: "campo", label: "PIS/COFINS - Aparelho", codigo: "pisCofinsAparelho" },
    { tipo: "campo", label: "PIS/COFINS - Acessório", codigo: "pisCofinsAcessorio" },
    { tipo: "campo", label: "ICMS - Chip", codigo: "icmsChip" },
    { tipo: "campo", label: "ICMS - Aparelho", codigo: "icmsAparelho" },
    { tipo: "campo", label: "ICMS - Acessório", codigo: "icmsAcessorio" },
    { tipo: "campo", label: "ICMS-ST Aparelho", codigo: "icmsSTAparelho" },
    { tipo: "campo", label: "ISS", codigo: "iss" },
    { tipo: "campo", label: "SIMPLES NACIONAL", codigo: "totalImpostoPieChart.totalImpostoSimplesNacional" },
    { tipo: "campo", label: "RECEITAS ADICIONAIS", codigo: "impostoReceitasAdicionais" },
    { tipo: "titulo", label: "RECEITA LÍQUIDA", codigo: "totalWaterfall.totalReceitaLiquida" },
    { tipo: "subtitulo", label: "CMV", codigo: "totalWaterfall.totalCmv" },
    { tipo: "campo", label: "APARELHO - CMV", codigo: "cmvAparelho" },
    { tipo: "campo", label: "CHIP - CMV", codigo: "cmvChip" },
    { tipo: "campo", label: "ACESSÓRIO - CMV", codigo: "cmvAcessorio" },
    { tipo: "campo", label: "RECEITAS ADICIONAIS - CMV", codigo: "cmvReceitasAdicionais" },
    { tipo: "titulo", label: "RECEITA OPERACIONAL", codigo: "totalWaterfall.totalReceitaOperacional" },
    { tipo: "campo", label: "PRODUTO", codigo: "receitaOperacionalProduto" },
    { tipo: "campo", label: "SERVIÇO", codigo: "receitaOperacionalServico" },
    { tipo: "titulo", label: "DESPESA", codigo: "totalWaterfall.totalDespesa" },
    { tipo: "subtitulo", label: "DESPESA PESSOAL", codigo: "totalDespesaPieChart.totalPessoal" },
    { tipo: "campo", label: "VENDEDOR", codigo: "vendedor" },
    { tipo: "campo", label: "GERENTE", codigo: "gerente" },
    { tipo: "campo", label: "CAIXA", codigo: "caixa" },
    { tipo: "campo", label: "ADMINISTRATIVO", codigo: "administrativo" },
    { tipo: "subtitulo", label: "DESPESA OCUPAÇÃO", codigo: "totalDespesaPieChart.totalOcupacao" },
    { tipo: "campo", label: "ALUGUEL", codigo: "aluguel" },
    { tipo: "campo", label: "ALUGUEL PERCENTUAL", codigo: "aluguelPorcentual" },
    { tipo: "campo", label: "CONDOMÍNIO", codigo: "condominio" },
    { tipo: "campo", label: "FUNDO PROMOÇÃO", codigo: "fundoPromocao" },
    { tipo: "campo", label: "DÉCIMO TERCEIRO ALUGUEL", codigo: "decimoTerceiroAluguel" },
    { tipo: "campo", label: "IPTU", codigo: "iptu" },
    { tipo: "campo", label: "CRÉDITO PIS/COFINS", codigo: "creditoPISCOFINS" },
    { tipo: "campo", label: "OUTRAS", codigo: "outras" },
    { tipo: "subtitulo", label: "DESPESA COM CARTÃO", codigo: "totalDespesaPieChart.totalCartao" },
    { tipo: "campo", label: "TAXA CARTÃO MDR", codigo: "taxaCartaoMDR" },
    { tipo: "campo", label: "ALUGUEL DA MÁQUINA", codigo: "aluguelMaquina" },
    { tipo: "subtitulo", label: "DESPESA ESTRUTURAL", codigo: "totalDespesaPieChart.totalEstrutural" },
    { tipo: "campo", label: "AÇÃO DE VENDAS", codigo: "acoesVendas" },
    { tipo: "campo", label: "CONTABILIDADE", codigo: "contabilidade" },
    { tipo: "campo", label: "ENERGIA", codigo: "energiaTaxas" },
    { tipo: "campo", label: "JURÍDICO", codigo: "juridico" },
    { tipo: "campo", label: "LIMPEZA", codigo: "limpeza" },
    { tipo: "campo", label: "MANUTENÇÃO", codigo: "manutencao" },
    { tipo: "campo", label: "MATERIAL DE ESCRITÓRIO", codigo: "materiais" },
    { tipo: "campo", label: "MOTOBOY", codigo: "motoboy" },
    { tipo: "campo", label: "SEGURO LOJA", codigo: "seguros" },
    { tipo: "campo", label: "SISTEMAS", codigo: "sistemas" },
    { tipo: "campo", label: "TELEFONE E INTERNET", codigo: "telefoniaInternet" },
    { tipo: "campo", label: "OUTROS", codigo: "outros" },
    { tipo: "campo", label: "EVENTOS", codigo: "eventos" },
    { tipo: "campo", label: "SANEAMENTO BÁSICO", codigo: "saneamentoBasico" },
    { tipo: "campo", label: "SEGURANÇA MONITORAMENTO", codigo: "segurancaMonitoramento" },
    { tipo: "campo", label: "CONTRIBUIÇÃO SINDICAL", codigo: "contribuicaoSindical" },
    { tipo: "campo", label: "EMPRESA TERCEIRIZADA", codigo: "empresaTerceirizada" },
    { tipo: "campo", label: "UNIFORMES", codigo: "uniformes" },
    { tipo: "campo", label: "RECRUTAMENTO SELEÇÃO", codigo: "recrutamentoSelecao" },
    { tipo: "campo", label: "PROCESSO JUDICIAL", codigo: "processoJudicial" },
    { tipo: "campo", label: "DESPESA GRÁFICA", codigo: "despesaGrafica" },
    { tipo: "campo", label: "FRETES CARRETO", codigo: "fretesCarreto" },
    { tipo: "campo", label: "REPRESENTAÇÕES VIAGENS", codigo: "representacoesViagensTransporte" },
    { tipo: "campo", label: "IRALUGUEL", codigo: "irAluguel" },
    { tipo: "campo", label: "PERDA ROUBO BAIXA ESTOQUE", codigo: "perdaRouboBaixaEstoque" },
    { tipo: "titulo", label: "EBITDA", codigo: "totalWaterfall.totalEbitda" },
    { tipo: "titulo", label: "% EBITDA", codigo: "percentualEbitda" },
    { tipo: "tituloIndicador", label: "INDICADORES", codigo: "" },
    { tipo: "subtitulo", label: "QTD PDV", codigo: "qtdPDV" },
    { tipo: "subtitulo", label: "FUNCIONÁRIOS", codigo: "" },
    { tipo: "campo", label: "VENDEDOR | QTD", codigo: "vendedorQtd" },
    { tipo: "campo", label: "VENDEDOR | UNITÁRIO", codigo: "vendedorUnitario" },
    { tipo: "campo", label: "GERENTE | QTD", codigo: "gerenteQtd" },
    { tipo: "campo", label: "GERENTE | UNITÁRIO", codigo: "gerenteUnitario" },
    { tipo: "campo", label: "CAIXA | QTD", codigo: "caixaQtd" },
    { tipo: "campo", label: "CAIXA | UNITÁRIO", codigo: "caixaUnitario" },
    { tipo: "campo", label: "ADMINISTRATIVO | QTD", codigo: "administrativoQtd" },
    { tipo: "campo", label: "ADMINISTRATIVO | UNITÁRIO", codigo: "administrativoUnitario" },
    { tipo: "subtitulo", label: "PRODUTO", codigo: "" },
    { tipo: "campo", label: "APARELHO | QTD", codigo: "aparelhoQtd" },
    { tipo: "campo", label: "APARELHO | TKM", codigo: "aparelhoTKM" },
    { tipo: "campo", label: "APARELHO | CMV", codigo: "aparelhoTKMCMV" },
    { tipo: "campo", label: "CHIP | QTD", codigo: "chipQtd" },
    { tipo: "campo", label: "CHIP | TKM", codigo: "chipTKM" },
    { tipo: "campo", label: "CHIP | CMV", codigo: "chipTKMCMV" },
    { tipo: "campo", label: "ACESSÓRIO | QTD", codigo: "acessorioQtd" },
    { tipo: "campo", label: "ACESSÓRIO | TKM", codigo: "acessorioTKM" },
    { tipo: "campo", label: "ACESSÓRIO | CMV", codigo: "acessorioTKMCMV" },
    { tipo: "campo", label: "RECEITAS ADICIONAIS | QTD", codigo: "receitasAdicionaisQtd" },
    { tipo: "campo", label: "RECEITAS ADICIONAIS | TKM", codigo: "receitasAdicionaisTKM" },
    { tipo: "campo", label: "RECEITAS ADICIONAIS | CMV", codigo: "receitasAdicionaisTKMCMV" },
    { tipo: "subtitulo", label: "VOLUME DATASYS", codigo: "" },
    { tipo: "campo", label: "PÓS PURO", codigo: "posPuro" },
    { tipo: "campo", label: "CONTROLE", codigo: "controle" },
    { tipo: "campo", label: "UPGRADE", codigo: "upgrade" }
  ];


  const headers = tableDREData.map(m => (m.mesAno));

  const lines = camposDataTable.map(m => {
    let item = { ...m };
    item.values = headers.map(i => {
      const splitCode = m.codigo.split(".")//faz um split para acessar os campos que estão dentro de objetos aninhados como totalDespesaPieChart.totalPessoal
      if (splitCode.length > 1) {
        const [nestedObj, nestedProp] = splitCode;
        const nestedData = tableDREData.find(f => f.mesAno === i)?.dados[nestedObj];//
        return nestedData ? nestedData[nestedProp] : undefined;
      } else {
        return tableDREData.find(f => f.mesAno === i)?.dados[m.codigo];
      }
    });
    return item;
  });

  return (
    <div>
      <Row>
        <Col lg="12" md="12" sm="12">
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <table no-border style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th style={stylesTable["tableFirstCollum"]}></th>
                  {headers.map((item, key) => (
                    <th key={key} style={stylesTable["header"]}>
                      {item}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {lines.map((item, key) => (
                  <tr key={key} style={stylesTable[item.tipo]}>
                    <td style={stylesTable["tableFirstCollum"]}>{item.label}</td>
                    {item.values.map((m, index) => {
                      const shouldFormatCurrency = !item.label.includes('QTD') && !item.label.includes('%')
                      const formattedValue = typeof m === 'number' && item.label === '% EBITDA'
                        ? m.toFixed(1)
                        : m;
                      return (
                        <td key={index} style={stylesTable["tableColluns"]}>
                          <strong>
                            {typeof m === 'number' && shouldFormatCurrency
                              ? parseFloat(formattedValue).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                              : formattedValue}
                          </strong>
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </Col>
      </Row>
    </div>
  );
}

const stylesTable = {
  header: { width: "100px", backgroundColor: "#878786", color: "#fff", opacity: 0.7 },
  titulo: { backgroundColor: "#0B3D86", color: "#fff", opacity: 0.7 },
  subtitulo: { backgroundColor: "#CECECC" },
  campo: {},
  tituloIndicador: { backgroundColor: "#0B3D86", color: "#fff" },
  tableFirstCollum: { padding: "8px", width: "150px" },
  tableColluns: { padding: "8px" }
};
